import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from '@vizit/feature-flags';

/**
 * GRE-113: returns whether Vizit scores should be hidden throughout Explore.
 *
 * Centralizes the `hide-explore-scores` LaunchDarkly flag so the Explore score
 * surfaces (asset thumbnails, image detail modal) share a single source of truth.
 * Defaults to `false` — scores remain visible until the flag is explicitly enabled.
 */
function useHideExploreScores(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.HIDE_EXPLORE_SCORES, false);
}

export { useHideExploreScores };
